/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TrendsChartRequestDTO { 
    clientId: number;
    brandId: number;
    viewBy: TrendsChartRequestDTO.ViewByEnum;
    chartViewBy: TrendsChartRequestDTO.ChartViewByEnum;
    conversionType: string;
    resolution: string;
    relativeDay: string;
    dateStart: string;
    dateStop: string;
    segments?: Array<string>;
    channels?: Array<string>;
    tactics?: Array<string>;
    isFiscalCalendarEnabled?: boolean;
}
export namespace TrendsChartRequestDTO {
    export type ViewByEnum = 'ROAS' | 'CPO';
    export const ViewByEnum = {
        Roas: 'ROAS' as ViewByEnum,
        Cpo: 'CPO' as ViewByEnum
    };
    export type ChartViewByEnum = 'roasI' | 'cpoI' | 'adjustmentFactor' | 'spend' | 'ordersLT' | 'salesLT' | 'ordersI' | 'salesI' | 'percOrdersI' | 'percSalesI';
    export const ChartViewByEnum = {
        RoasI: 'roasI' as ChartViewByEnum,
        CpoI: 'cpoI' as ChartViewByEnum,
        AdjustmentFactor: 'adjustmentFactor' as ChartViewByEnum,
        Spend: 'spend' as ChartViewByEnum,
        OrdersLt: 'ordersLT' as ChartViewByEnum,
        SalesLt: 'salesLT' as ChartViewByEnum,
        OrdersI: 'ordersI' as ChartViewByEnum,
        SalesI: 'salesI' as ChartViewByEnum,
        PercOrdersI: 'percOrdersI' as ChartViewByEnum,
        PercSalesI: 'percSalesI' as ChartViewByEnum
    };
}


